import { Injectable, inject } from '@angular/core';
import { DomService } from '@nano/common/dom';
import { CONFIG } from '@nano/core/config';
import { ScriptIntegrationService } from '../integration';

@Injectable({ providedIn: 'root' })
export class UsersnapService implements ScriptIntegrationService {
  private config = inject(CONFIG);

  constructor(private domService: DomService) {}

  addScriptToDom(): void {
    if (!this.config.usersnapEnabled) {
      return;
    }

    try {
      const script = this.domService.createHTMLScriptElement(`https://api.usersnap.com/load/${this.config.usersnapApiKey}.js`, true);
      this.domService.addScriptToBody(script);
    } catch (error) {
      // This runs from an APP_INITIALIZER, and setting a script's src goes through the Trusted
      // Types default policy, which throws for a URL it does not recognise. Letting that
      // propagate aborts the bootstrap and leaves the user with a blank page - far more than a
      // feedback widget is worth.
      console.error('Failed to add the Usersnap widget to the DOM:', error);
    }
  }
}
